import useVuelidate from '@vuelidate/core';
import type { FlowOperatorMetadata, ValidationResult, ShopsListsMin } from '@/types/flow-types';
import { TypeCampaignEnum } from '@/types';
import { includesValuesValidator, requiredWithMessage } from '@/helpers/CustomValidator';
import Form from './Form.vue';

export interface ListData {
  id_list: ShopsListsMin[];
  multiplebox_type: number;
}

export const createDefaultData = (overrides: Partial<ListData> = {}): ListData => ({
  id_list: [],
  multiplebox_type: 0,
  ...overrides,
});

export const List: FlowOperatorMetadata<ListData> = {
  id: 'boxlist',
  kind: 'action',
  label: 'flows.operators.list.label',
  icon: 'fa-list',
  hasConfiguration: true,

  availableIn: [TypeCampaignEnum.AUTOMATION, TypeCampaignEnum.BULK],

  incompatibilities: {
    automation: {
      nextOperators: ['boxabandonpanier', 'boxperiodiclaunching'],
    },
    bulk: {
      nextOperators: ['boxabandonpanier', 'boxperiodiclaunching', 'boxchoosebulklist', 'boxaudiencesetup'],
    },
  },

  Form,

  defaultData: createDefaultData,

  outputs(data: ListData): number {
    return 1;
  },

  async validate(data: ListData): Promise<ValidationResult> {
    const normalizedData = {
      ...data,
      multiplebox_type: Number(data.multiplebox_type),
    };

    const rules = {
      id_list: {
        requiredWithMessage: requiredWithMessage(),
      },
      multiplebox_type: {
        requiredWithMessage: requiredWithMessage(),
        includesValuesValidator: includesValuesValidator([0, 1]),
      },
    };

    const v$ = useVuelidate(rules, normalizedData);
    const success = await v$.value.$validate();

    return {
      success,
      validate: v$,
    };
  },

  beforeInsert(data: ListData): ListData {
    let dataToReturn: ListData = data;
    if (data.id_list.length > 0) {
      const formatData = data.id_list.reduce((accumulator: any, currentValue) => {
        accumulator[currentValue.id_shop_list] = currentValue.name;
        return accumulator;
      }, {});
      dataToReturn = {
        ...dataToReturn,
        id_list: formatData as any,
      };
    }
    return dataToReturn;
  },
};

export default List;
